import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { StartOrderService } from '../../custom-start-order/start-order.service';
import { CmsComponentData, TruncatePipe } from '@spartacus/storefront';
import { ContentService } from '../../spartacus/services/content.service';
import { CmsBannerComponent } from '@spartacus/core';
import { Observable } from 'rxjs';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';

@Component({
    selector: 'app-orders-cart-review-page',
    templateUrl: './orders-cart-review-page.component.html',
    styleUrls: ['./orders-cart-review-page.component.scss'],
    standalone: false
})
export class OrdersCartReviewPageComponent {
  seasonValue = '';
  aqivCost: any = 0;
  qivcCost: any = 0;
  reviewPageData: any;
  checkbox: boolean = false;
  materialcheck=false;
  maxDeliverySlots:any;
  enablePage: any
  isLoading: boolean = false;
  totalCost: any = 0;
  aqiv: any;
  qivc: any;
  deliverySlotArray: any;
  reviewdelivery:any;
  landingapi: any;
  inseason: string = '';
  preseason: string = '';
  prepreseason: string = '';
  isAllChecked: boolean=false;
  isAllFieldsValid: boolean=false;
  reviewcontent:any;
  reviewtext: Observable<any> = this.component.data$;
  constructor(private el:ElementRef,private dialogservice:ApiFailureDialogService,public component: CmsComponentData<CmsBannerComponent>,private cdr: ChangeDetectorRef, private userInfoService: UserInfoService, private startOrderService: StartOrderService, private contentservice: ContentService) {

  }
  ngOnInit() {
    this.reviewtext.subscribe((res: any) => {
      this.reviewcontent=res;
      this.cdr.detectChanges();
    });
    this.contentservice.startapi().subscribe(data => {
      this.landingapi=data;
      this.inseason=this.landingapi?.currentInSeason;
      this.preseason=this.landingapi?.prePreSeason;
      this.prepreseason=this.landingapi?.prePreSeason;
      this.cdr.detectChanges();
    });
    this.userInfoService.getstartorderseason().subscribe(
      (seasonValue: any) => {
        const body=<HTMLElement>document.querySelector("body");
        this.seasonValue = seasonValue;
       if(this.prepreseason==this.seasonValue){

        body.classList.add("prepreseason");
      }else{
        body.classList.remove("prepreseason");
      }
        this.reviewdelivery = seasonValue?.split("-")[0];
    
        this.userInfoService.getEnablePage().subscribe(
          (data: any) => {
            this.enablePage = data;
    
            if (this.enablePage.showukCartReviewSection) {
              this.isLoading = true;
              this.scrollToTop();
    
              this.startOrderService.getProductData().subscribe(
                (data: any) => {
                  if(data?.errorCode=="500" && localStorage.getItem('FailureDailog') != 'true'){
                    this.dialogservice.openErrorDialog();
                    localStorage.setItem('FailureDailog', 'true');
                    this.isLoading = false;
                    this.cdr.detectChanges();
                          }
                  if (data && this.enablePage.showukCartReviewSection) {
                    this.reviewPageData = data;
                    this.materialcheck = this.reviewPageData?.isMaterialsConsentGiven;
                    this.maxDeliverySlots = !this.reviewPageData.deliverySlotConstraintList
                      ? 4
                      : (this.reviewPageData.deliverySlotConstraintList.maxDeliverySlots) - 1;
    
                    this.deliverySlotArray = this.reviewPageData.reviewData.cartEntries[0].products[0].deliverySlots
                      ? this.reviewPageData.reviewData.cartEntries[0].products[0].deliverySlots
                      : this.reviewPageData.reviewData.cartEntries[0].products[1].deliverySlots;
    
                    this.constructReviewDataSource();
                    this.isLoading = false;
                    this.cdr.detectChanges();
                    this.startOrderService.setProductData(null);
                  }
                },
                (error) => {
                  console.error('Error fetching product data:', error);
                  this.isLoading = false;
    
                  const obj = {
                    showukOrdersLeftSection: false,
                    showukOrdersBanner: false,
                    showukCartBanner: true,
                    showukCartReviewSection: false,
                    showAmendThankYouPage: false,
                    showSorryPage: true
                  };
    
                  this.userInfoService.setEnablePage(obj);
                  this.scrollToTop();
                  this.cdr.detectChanges();
                }
              );
              this.startOrderService.geterrorData().subscribe((val:boolean)=>{
                if(val==true){
                  this.isLoading=false;
                  this.cdr.detectChanges();
                }
              });
            }
          },
          (error) => {
            console.error('Error fetching enable page:', error);
            this.isLoading = false;
            this.cdr.detectChanges();
          }
        );
      },
      (error) => {
        console.error('Error fetching start order season:', error);
        this.isLoading = false;
        this.cdr.detectChanges();
      }
    );
   
  }
  numberWithCommas(number: number) {
    var parts = number.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
  }
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  handleOnInputValueChange(value: any, field: string, index: number) {
    if (field == 'firstName') {
      var letters = /^[A-Za-z ]+$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.firstNameErrorMsg = (!value || value == '' ? 'Please enter a first name' : (value.match(letters) ? '' : 'Please enter only letters'));
    } else if (field == 'email') {
      var letters=/^(?=(.{1,64}@.{1,255}))([!#$%&'*+\-\/=?\^_`{|}~a-zA-Z0-9}]{1,64}(\.[!#$%&'*+\-\/=?\^_`{|}~a-zA-Z0-9]{0,}){0,})@((\[(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}\])|([a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{2,63}){1,}))$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.emailErrorMsg = (!value || value == '' ? 'Please enter a valid email address.' : (value.match(letters) ? '' : 'Please enter a valid email address.'));
    } else if (field == 'phone') {
      var letters = /^[0-9]{10,11}$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.phoneNumberErrorMsg = (!value || value == '' ? 'Please enter a valid UK format phone number.' : (value.match(letters) ? value.length > 11 ? 'Please enter no more than 11 characters.' : '' : 'Please enter only Numbers.'));
    } else if (field == 'ext') {
      var letters = /^[0-9]+$/;
      this.reviewPageData.reviewData.cartEntries[index].deliveryContact.phoneextErrorMsg = ( value != '' ? (value.match(letters)  ? '':'Please enter only Numbers.') :'');
    } 
    else if (field == 'licenseInfoName') {
      var letters = /^[A-Za-z ]+$/;
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.nameErrorMsg = (!value || value == '' ? 'Please enter a licence name.' : (value.match(letters) ? '' : 'Please enter only letters.'));
    } else if (field == 'licenseInfoNumber') {
      var letters = /^[A-Za-z0-9]+$/;
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.numberErrorMsg = (!value || value == '' ? 'Please enter a valid licence number.' : (value.match(letters) ? '' : 'Please enter only Letters and Numbers'));
    } else if (field == 'checkbox') {
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checked = value;
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checkboxErrorMsg = this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checked ? '' : 'Please select the checkbox';
    } else if (field == 'commonCheckbox') {
      this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checkboxErrorMsg = this.reviewPageData.reviewData.cartEntries[index].licenseInfo.checked ? '' : 'Please select the checkbox';
    } else if (field == 'nhs') {
      if(this.reviewPageData.reviewData.businessType == 'GP Medical Practice') {
        const regex = /^[A-Za-z]{1}[0-9]{5}$/;
        this.reviewPageData.reviewData.cartEntries[index].nhsErrorMsg = (value != '' ? (value.match(regex) ? '' : 'Please provide a valid NHS code e.g. Y02906'): '');
      }
      if(this.reviewPageData.reviewData.businessType == 'Pharmacy') {
        const regex = /^[F|f]([A-Za-z]|[0-9]){4}$/;
        this.reviewPageData.reviewData.cartEntries[index].nhsErrorMsg = (value != '' ? ( value.match(regex) ? '' : 'Please provide a valid NHS code e.g. F1J4D'): '');
      }
      if (this.reviewPageData.reviewData.businessType == "Hospitals - Public" || this.reviewPageData.reviewData.businessType == "Hospitals - Private" || this.reviewPageData.reviewData.businessType == "Nursing Homes" || this.reviewPageData.reviewData.businessType == "Correctional Facility" || this.reviewPageData.reviewData.businessType == "Wholesaler") {
        const regex = /^.{6,6}$/;
        this.reviewPageData.reviewData.cartEntries[index].nhsErrorMsg = (value != '' ? (value.match(regex) ? '' : 'Please provide a valid NHS code'):'');
      }
    }
  }
  handlepreprebookvalidation(event: any){
   
    this.reviewPageData.reviewData.cartEntries.forEach((entry: any, index: number) => {
      this.handleOnInputValueChange(entry.deliveryContact.name, 'firstName', index);
      this.handleOnInputValueChange(entry.deliveryContact.email, 'email', index);
      this.handleOnInputValueChange(entry.deliveryContact.phone, 'phone', index);
      this.handleOnInputValueChange(entry.licenseInfo.name, 'licenseInfoName', index);
      this.handleOnInputValueChange(entry.licenseInfo.number, 'licenseInfoNumber', index);
      this.handleOnInputValueChange(entry.licenseInfo.checked, 'commonCheckbox', index);
      if (entry.deliveryContact.firstNameErrorMsg != '' || entry.deliveryContact.emailErrorMsg != '' || entry.deliveryContact.phoneNumberErrorMsg != '' ||  entry.deliveryContact.phoneextErrorMsg != ''||  entry.licenseInfo.nameErrorMsg != '' || entry.licenseInfo.numberErrorMsg != '' || entry.licenseInfo.checkboxErrorMsg != '') {
       this.isAllFieldsValid=false
        event.preventDefault();
      } else {
       this.isAllFieldsValid=true;
 
      }
    })
    
    this.cdr.detectChanges();
  }
  handleOnCommonCheckboxvalueChange(event: any) {
    let array: any = [];
    this.reviewPageData.reviewData.cartEntries.forEach((entry: any, index: number) => {
      this.handleOnInputValueChange(entry.deliveryContact.name, 'firstName', index);
      this.handleOnInputValueChange(entry.deliveryContact.email, 'email', index);
      this.handleOnInputValueChange(entry.deliveryContact.phone, 'phone', index);
      this.handleOnInputValueChange(entry.licenseInfo.name, 'licenseInfoName', index);
      this.handleOnInputValueChange(entry.licenseInfo.number, 'licenseInfoNumber', index);
      this.handleOnInputValueChange(entry.licenseInfo.checked, 'commonCheckbox', index);
      if (entry.deliveryContact.firstNameErrorMsg != '' || entry.deliveryContact.emailErrorMsg != '' || entry.deliveryContact.phoneNumberErrorMsg != '' ||  entry.deliveryContact.phoneextErrorMsg != ''||  entry.licenseInfo.nameErrorMsg != '' || entry.licenseInfo.numberErrorMsg != '' || entry.licenseInfo.checkboxErrorMsg != '') {
        array.push(false);
        event.preventDefault();
      } else {
        array.push(true);
      }
    })
    this.checkbox = array.every((val: any) => val == true);
    if(!this.checkbox) {
      event.preventDefault();
    }
    this.cdr.detectChanges();
  }
  handleOnOrderClick(value: string) {
    this.isLoading = true;
    let cartEntries: any = [];
    this.reviewPageData.reviewData.cartEntries.forEach((entry: any) => {
      const obj: any = {
        requestType: this.reviewPageData.priceResponse.requestType,
        sor: this.reviewPageData.priceResponse.SOR,
        creditDays: this.reviewPageData.priceResponse.creditDays,
        poNumber: entry.poNumber,
        // totalQty: 0, wt value to map
        orderID: entry.orderID,
        orderStatus: entry.orderStatus,
        qty50to64y: entry.qty50to64y,
        nhsCode: entry.nhsCode,
        orderModifiedAttribures: "",
        season: this.reviewPageData.selectedSeason,
        shippinglocID: entry.shippinglocID,
        products: entry.products,
        licenseInfo: entry.licenseInfo,
        deliveryContact: entry.deliveryContact
      }
      cartEntries.push(obj)
    })
    const payload = {
      priceResponse : this.reviewPageData.priceResponse,
      saveOrderClosed: this.reviewPageData.saveOrderClosed,
      selectedSeason: this.reviewPageData.selectedSeason,
      confirmedOrder: this.reviewPageData.confirmedOrder,
      isMaterialsConsentGiven:this.materialcheck,
      orderType: 'confirmOrder',
      reviewData: {
        businessType: this.reviewPageData.reviewData.businessType,
        soldToID: this.reviewPageData.reviewData.soldToID,
        salesContact: this.reviewPageData.reviewData.salesContact,
        cartEntries: cartEntries
      }
    };
    this.startOrderService.placeOrder(payload).subscribe((data:any) =>{
      if(data == 'success') {
          const obj = {
            showukOrdersLeftSection: false,
            showukOrdersBanner: false,
            showukCartBanner: true,
            showukCartReviewSection: false,
            showConfirmThankYouPage: true,
            showSorryPage: false
          }
          this.userInfoService.setEnablePage(obj);
          this.scrollToTop();
          this.isLoading = false;
          this.cdr.detectChanges();
        
      } else {
        this.isLoading = false;
        const obj = {
          showukOrdersLeftSection: false,
          showukOrdersBanner: false,
          showukCartBanner: true,
          showukCartReviewSection: false,
          showAmendThankYouPage: false,
          showSorryPage: true
        }
        this.userInfoService.setEnablePage(obj);
        this.scrollToTop();
        this.cdr.detectChanges();
      }
    }, (error) => {
      console.log('error: ', error);
      this.isLoading = false;
      const obj = {
        showukOrdersLeftSection: false,
        showukOrdersBanner: false,
        showukCartBanner: true,
        showukCartReviewSection: false,
        showAmendThankYouPage: false,
        showSorryPage: true
      }
      this.userInfoService.setEnablePage(obj);
      this.scrollToTop();
      this.cdr.detectChanges();
    })
  }
  constructReviewDataSource() {
    let aqiv: any = [];
    let qivc: any = [];
    let totalProductCost: any =[];
    this.reviewPageData.reviewData.cartEntries.forEach((entry:any) => {
      entry.deliveryContact['firstNameErrorMsg'] = '';
      entry.deliveryContact['emailErrorMsg'] = '';
      entry.deliveryContact['phoneNumberErrorMsg'] = '';
      entry.deliveryContact['phoneextErrorMsg'] = '';
      entry.licenseInfo['nameErrorMsg'] = '';
      entry.licenseInfo['numberErrorMsg'] = '';
      entry.licenseInfo['checkboxErrorMsg'] = '';
      entry.licenseInfo['checked'] = false;
      entry['nhsCode'] = '';
      entry['nhsErrorMsg'] = '';
      entry['poNumber'] = '';
      // const filterLocation = this.reviewPageData.shippingData.filter((location:any) =>{return entry.shippinglocID == location.locID});
      // entry['address'] = filterLocation[0].address;
      entry['locname'] = this.reviewPageData.orderSummary.delLocation;
      // entry['state'] = filterLocation[0].state;
      let  sumSaleProduct:any = [];
      let productArray: any = [];
        if(entry.products.length == 1) {
          this.reviewPageData.productList.forEach((el:any) => {
            if(el.code != entry.products[0].materialID) {
              const obj = {
                  materialID: el.code.toString(),
                  qty: 0,
                }
                productArray.push(obj);
            } else {
              productArray.push(entry.products[0])
            }
          })
          entry.products = productArray;
          }
      entry.products.forEach((product: any,index: number) => {
        const filterProduct = this.reviewPageData.productList.filter((prodList:any) =>{return product.materialID == prodList.code});
        const filterMaterial = this.reviewPageData.priceResponse.materials.filter((material:any) =>{return product.materialID == material.materialID});
        product['baseName'] = filterProduct[0].baseName;
        const value = product.qty == 0 ? 0 : product.qty * Number(filterMaterial[0].salePrice);
        sumSaleProduct.push(value);
        if(product.baseName == 'AQIV' || product.baseName == 'Aujemflu') {
          aqiv.push(product.qty);
        } else if(product.baseName == 'QIVC') {
          qivc.push(product.qty);
        }
        if(product.deliverySlots) {
          product.deliverySlots.forEach((value: any) => {
            if(!value.quantity) {
              value['quantity'] = 0;
            }
          })
        }
      })
      totalProductCost.push(parseFloat((sumSaleProduct.reduce((partialSum: number, value: number) => partialSum + value, 0)).toFixed(2)))
      entry['prodCost'] = this.numberWithCommas((sumSaleProduct.reduce((partialSum: number, value: number) => partialSum + value, 0)).toFixed(2));
      this.aqivCost = this.numberWithCommas((aqiv.reduce((partialSum: number, value: number) => partialSum + value, 0)));
      this.qivcCost = this.numberWithCommas((qivc.reduce((partialSum: number, value: number) => partialSum + value, 0)));
      this.totalCost = this.numberWithCommas((totalProductCost.reduce((partialSum: number, value: number) => partialSum + value, 0)).toFixed(2))
    })
  }
  checkForErrrors(){
    const licCheckbox = this.el.nativeElement.querySelectorAll('.licenceCheckbox');
     this.isAllChecked = Array.from(licCheckbox).every((checkbox:any )=> checkbox.checked);
    const hasErrorFields = this.el.nativeElement.querySelectorAll('.has-error');
    this.isAllFieldsValid = hasErrorFields.length === 0 && this.isAllChecked;
    this.cdr.detectChanges();
  }
}
